import React from "react";

const initialState = {
  authUser: null,
};

const StateContext = React.createContext(initialState);

const stateReducer = (state, action) => {
  switch (action.type) {
    case "SET_AUTH_USER":
      return {
        ...state,
        authUser: action.payload,
      };
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
};

const StateProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(stateReducer);

  return (
    <StateContext.Provider value={{ state, dispatch }}>
      {children}
    </StateContext.Provider>
  );
};

const useStateContext = () => {
  const context = React.useContext(StateContext);

  if (context) {
    return context;
  }

  throw new Error(`useStateContext must be used within a StateContextProvider`);
};

export { StateProvider, useStateContext };
